// extracted by mini-css-extract-plugin
export var actionText = "_q0-4";
export var container = "_q0-0";
export var leftSection = "_q0-1";
export var rightSection = "_q0-2";
export var settingsButton = "_q0-6";
export var settingsIcon = "_q0-7";
export var shortcut = "_q0-5";
export var shortcutGroup = "_q0-3";